export const variantStyles = {
    primary: {
        default: {
            textColor: 'interactive.primary.active.onColor',
            bgColor: 'interactive.primary.active.default',
            borderColor: 'interactive.primary.active.default',
            fontToken: 'bodyLargeMedium',
        },
        pressed: {
            textColor: 'interactive.primary.pressed.onColor',
            bgColor: 'interactive.primary.pressed.default',
            borderColor: 'interactive.primary.pressed.default',
        },
        focused: {
            textColor: 'interactive.primary.focus.onColor',
            bgColor: 'interactive.primary.focus.default',
            borderColor: 'interactive.primary.focus.default',
            focusedBorderColor: 'interactive.primary.focus.strokeOpacity',
        },
        disabled: {
            textColor: 'interactive.primary.disabled.onColor',
            bgColor: 'interactive.primary.disabled.default',
            borderColor: 'interactive.primary.disabled.default',
        },
        hover: {
            textColor: 'interactive.primary.pressed.onColor',
            bgColor: 'interactive.primary.pressed.default',
            borderColor: 'interactive.primary.pressed.default',
        },
        outline: {
            width: 0,
        },
    },
    secondary: {
        default: {
            textColor: 'interactive.secondary.active.onColor',
            bgColor: 'interactive.secondary.active.defaultFill',
            borderColor: 'interactive.secondary.active.defaultStroke',
            fontToken: 'bodyLargeMedium',
        },
        pressed: {
            textColor: 'interactive.secondary.pressed.onColor',
            bgColor: 'interactive.secondary.pressed.defaultFill',
            borderColor: 'interactive.secondary.pressed.defaultStroke',
        },
        focused: {
            textColor: 'interactive.secondary.focus.onColor',
            bgColor: 'interactive.secondary.focus.defaultFill',
            borderColor: 'interactive.secondary.focus.defaultStroke',
            focusedBorderColor: 'interactive.secondary.focus.strokeOpacity',
        },
        disabled: {
            textColor: 'interactive.secondary.disabled.onColor',
            bgColor: 'interactive.secondary.disabled.defaultFill',
            borderColor: 'interactive.secondary.disabled.defaultStroke',
        },
        hover: {
            textColor: 'interactive.secondary.pressed.onColor',
            bgColor: 'interactive.secondary.pressed.defaultFill',
            borderColor: 'interactive.secondary.pressed.defaultStroke',
        },
        outline: {
            width: 1.5,
        },
    },
    tertiary: {
        default: {
            textColor: 'interactive.tertiary.active.onColor',
            bgColor: 'interactive.tertiary.active.default',
            borderColor: 'transparent',
            fontToken: 'bodyLargeMedium',
        },
        pressed: {
            textColor: 'interactive.tertiary.pressed.onColor',
            bgColor: 'interactive.tertiary.pressed.default',
            borderColor: 'transparent',
        },
        focused: {
            textColor: 'interactive.tertiary.focus.onColor',
            bgColor: 'interactive.tertiary.focus.default',
            borderColor: 'transparent',
            focusedBorderColor: 'interactive.tertiary.focus.strokeOpacity',
        },
        disabled: {
            textColor: 'interactive.tertiary.disabled.onColor',
            bgColor: 'interactive.tertiary.disabled.default',
            borderColor: 'transparent',
        },
        hover: {
            textColor: 'interactive.tertiary.pressed.onColor',
            bgColor: 'interactive.tertiary.pressed.default',
            borderColor: 'transparent',
        },
        outline: {
            width: 0,
        },
    },
    danger: {
        default: {
            textColor: 'alert.danger.50.active.onColor',
            bgColor: 'alert.danger.50.active.default',
            borderColor: 'alert.danger.50.active.default',
            fontToken: 'bodyLargeMedium',
        },
        pressed: {
            textColor: 'alert.danger.50.pressed.onColor',
            bgColor: 'alert.danger.50.pressed.default',
            borderColor: 'alert.danger.50.pressed.default',
        },
        focused: {
            textColor: 'alert.danger.50.focus.onColor',
            bgColor: 'alert.danger.50.focus.default',
            borderColor: 'alert.danger.50.focus.default',
            focusedBorderColor: 'transparent',
        },
        disabled: {
            textColor: 'alert.danger.50.disabled.onColor',
            bgColor: 'alert.danger.50.disabled.default',
            borderColor: 'alert.danger.50.disabled.default',
        },
        hover: {
            textColor: 'alert.danger.50.pressed.onColor',
            bgColor: 'alert.danger.50.pressed.default',
            borderColor: 'alert.danger.50.pressed.default',
        },
        outline: {
            width: 0,
        },
    },
    textPrimary: {
        default: {
            textColor: 'interactive.text.active',
            bgColor: 'transparent',
            borderColor: 'transparent',
            fontToken: 'bodyBaseMedium',
        },
        pressed: {
            textColor: 'interactive.text.pressed',
            bgColor: 'transparent',
            borderColor: 'transparent',
        },
        focused: {
            textColor: 'interactive.text.focus',
            bgColor: 'transparent',
            borderColor: 'transparent',
            focusedBorderColor: 'transparent',
        },
        disabled: {
            textColor: 'interactive.text.disabled',
            bgColor: 'transparent',
            borderColor: 'transparent',
        },
        hover: {
            textColor: 'interactive.text.pressed',
            bgColor: 'transparent',
            borderColor: 'transparent',
        },
        outline: {
            width: 0,
        },
    },
    textSecondary: {
        default: {
            textColor: 'interactive.text.active',
            bgColor: 'transparent',
            borderColor: 'transparent',
            fontToken: 'bodyBaseMedium',
        },
        pressed: {
            textColor: 'interactive.text.pressed',
            bgColor: 'transparent',
            borderColor: 'transparent',
        },
        focused: {
            textColor: 'interactive.text.focus',
            bgColor: 'transparent',
            borderColor: 'transparent',
            focusedBorderColor: 'transparent',
        },
        disabled: {
            textColor: 'interactive.text.disabled',
            bgColor: 'transparent',
            borderColor: 'transparent',
        },
        hover: {
            textColor: 'interactive.text.pressed',
            bgColor: 'transparent',
            borderColor: 'transparent',
        },
        outline: {
            width: 0,
        },
    },
};
